/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 3.04.21
 *
 */
exports.referrerIdToName = function(referrerId){
    switch (referrerId){
        case "":
            break;
        case "106142":
            return "Jennifer Liberi-Middleton"
        case "129059":
            return "Lori Young"
        case "129932":
            return "Jessica Henderson"
        // case "23":
        //     return "Juan Pablo Sans"
    }
}
